module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55ae7086"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/Dashboard.vue
// module id = 688
// module chunks = 1